import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27af2f28"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-source"
}
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "絵文字名", -1 /* HOISTED */))
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 0,
  class: "duplicate-warning"
}
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "テキスト", -1 /* HOISTED */))
const _hoisted_8 = { class: "options-row" }
const _hoisted_9 = { class: "option-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "フォント", -1 /* HOISTED */))
const _hoisted_11 = { class: "option-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "揃え", -1 /* HOISTED */))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "stretch" }, "両端", -1 /* HOISTED */))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "center" }, "中央", -1 /* HOISTED */))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "left" }, "左", -1 /* HOISTED */))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "right" }, "右", -1 /* HOISTED */))
const _hoisted_17 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "option-item color-option" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "色", -1 /* HOISTED */))
const _hoisted_20 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontSelectBlock = _resolveComponent("FontSelectBlock")!
  const _component_FontColorSelectBlock = _resolveComponent("FontColorSelectBlock")!
  const _component_OutlineBlock = _resolveComponent("OutlineBlock")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createCommentVNode(" 絵文字名 "),
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("input", {
            type: "text",
            value: _ctx.conf.emojiName,
            class: _normalizeClass(["form-input", { 'input-error': _ctx.isEmojiNameDuplicate }]),
            placeholder: "英数字のみ",
            onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.validateEmojiName($event.target.value))),
            onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.preventNonAlphanumeric && _ctx.preventNonAlphanumeric(...args))),
            onCompositionend: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleCompositionEnd && _ctx.handleCompositionEnd(...args)))
          }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_4),
          (_ctx.isEmojiNameDuplicate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, " この絵文字名は既に使用されています "))
            : _createCommentVNode("v-if", true)
        ]),
        _createCommentVNode(" テキスト入力 "),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.conf.content) = $event)),
            class: "form-textarea",
            placeholder: "絵文字にしたい文字を入力",
            rows: "2"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, _ctx.conf.content]
          ])
        ]),
        _createCommentVNode(" オプション行 "),
        _createElementVNode("div", _hoisted_8, [
          _createCommentVNode(" フォント選択 "),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_FontSelectBlock, {
              modelValue: _ctx.conf.font,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.conf.font) = $event)),
              "show-details": false,
              compact: ""
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _createCommentVNode(" 揃え "),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.conf.align) = $event)),
              class: "form-select"
            }, _hoisted_17, 512 /* NEED_PATCH */), [
              [_vModelSelect, _ctx.conf.align]
            ])
          ]),
          _createCommentVNode(" 色 "),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createVNode(_component_FontColorSelectBlock, {
              modelValue: _ctx.conf.color,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.conf.color) = $event)),
              gradient: _ctx.conf.gradient,
              "onUpdate:gradient": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.conf.gradient) = $event)),
              "show-details": false,
              compact: ""
            }, null, 8 /* PROPS */, ["modelValue", "gradient"])
          ])
        ]),
        _createCommentVNode(" 縁取り（シンプル化） "),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_OutlineBlock, {
            modelValue: _ctx.conf.outlines,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.conf.outlines) = $event)),
            thickness: _ctx.conf.outlineThickness,
            "onUpdate:thickness": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.conf.outlineThickness) = $event)),
            posX: _ctx.conf.outlineX,
            "onUpdate:posX": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.conf.outlineX) = $event)),
            posY: _ctx.conf.outlineY,
            "onUpdate:posY": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.conf.outlineY) = $event)),
            "base-color": _ctx.conf.color,
            "show-details": false,
            compact: ""
          }, null, 8 /* PROPS */, ["modelValue", "thickness", "posX", "posY", "base-color"])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}